export default __webpack_public_path__ + "static/media/error-outline.d2ebf05f.svg";